<template>
    <v-footer color="surface" class="pt-10 pb-4">
        <v-container style="max-width: 1200px;">
            <v-row>
                <v-col cols="12" sm="4" class="mb-4 mb-sm-0">
                    <img :src="logo" alt="UQM" width="110" height="50" class="d-block mb-3" />
                    <p class="text-body-2 text-medium-emphasis mb-0">
                        Autoplay delle videolezioni e database di domande d'esame per le università
                        telematiche. Mantenuto da studenti, per studenti.
                    </p>
                </v-col>

                <!-- Link site-wide: presenti in ogni pagina e nell'HTML prerenderizzato,
                     quindi crawlabili (i link dentro il menu a tendina non lo sono). -->
                <v-col cols="12" sm="4" class="mb-4 mb-sm-0">
                    <div class="text-subtitle-2 font-weight-bold mb-2">Guide</div>
                    <ul class="footer-list">
                        <li v-for="guide in guides" :key="guide.path">
                            <router-link :to="guide.path" class="footer-link">{{ guide.navTitle }}</router-link>
                        </li>
                        <li>
                            <router-link to="/guide" class="footer-link">Tutte le guide</router-link>
                        </li>
                    </ul>
                </v-col>

                <v-col cols="12" sm="4">
                    <div class="text-subtitle-2 font-weight-bold mb-2">UQM</div>
                    <ul class="footer-list">
                        <li><router-link to="/" class="footer-link">Home</router-link></li>
                        <li>
                            <a :href="chromeStoreLink" target="_blank" rel="noopener" class="footer-link">
                                Estensione Chrome
                            </a>
                        </li>
                        <li><router-link to="/app" class="footer-link">Cerca domande</router-link></li>
                        <li>
                            <a href="#" class="footer-link" @click.prevent="openPayPalLink">Sostieni il progetto</a>
                        </li>
                    </ul>

                    <div class="text-caption text-medium-emphasis mt-3">
                        <span v-for="(platform, i) in platforms" :key="platform.name">
                            {{ platform.name }}<span v-if="platform.status === 'testing'"> (in test)</span
                            ><span v-if="i < platforms.length - 1"> · </span>
                        </span>
                    </div>
                </v-col>
            </v-row>

            <v-divider class="my-4" />

            <p class="footer-text text-medium-emphasis mb-0">
                © {{ year }} UQM - University Questions Manager · v{{ appVersion }}
            </p>
        </v-container>
    </v-footer>
</template>

<script>
import { openPayPalLink, CHROME_STORE_LINK } from '../utils'
import { GUIDES } from '../content/guides'
import { PLATFORMS } from '../content/platforms'
import logo from '../assets/uqm-logo.png'

export default {
    name: 'AppFooter',
    setup() {
        return {
            appVersion: process.env.VUE_APP_VERSION,
            year: new Date().getFullYear(),
            guides: GUIDES,
            platforms: PLATFORMS,
            logo,
            chromeStoreLink: CHROME_STORE_LINK,
            openPayPalLink
        }
    }
}
</script>

<style scoped>
.footer-text {
    font-size: 0.75rem;
}

.footer-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.footer-list li {
    margin-bottom: 0.35rem;
}

.footer-link {
    color: rgb(var(--v-theme-on-surface));
    opacity: 0.75;
    text-decoration: none;
    font-size: 0.875rem;
}

.footer-link:hover {
    opacity: 1;
    color: rgb(var(--v-theme-primary));
    text-decoration: underline;
}
</style>
